import moment from "moment";
import { Geotag } from "../models";
import { formatDateToStr } from "src/utils";

const getHour = time => Math.floor(time / 100);

/**
 *
 * @param {number} day
 * @param {Geotag[]} logs
 * @param {number} offset
 */
function getLogsOfTheDay(day, logs, offset = 0) {
  const res = [];

  for (const log of logs) {
    const date = Math.floor(log.ixDatetime / 10000);
    const targetDate =
      getHour(log.ixDatetime % 10000) < offset
        ? parseInt(
            moment(formatDateToStr(date), "YYYY-MM-DD")
              .add(1, "day")
              .format("YYYYMMDD")
          )
        : date;

    if (day === targetDate) res.push(log);
  }

  return res;
}

export default getLogsOfTheDay;
